import {t} from "@lingui/macro";
import {Type} from "../helper";

export function getParentUrl(transactionType) {
    switch (transactionType) {
        case Type.sale_quote:
        case Type.sale_order:
        case Type.sale_delivery_order:
        case Type.sale_invoice:
        case Type.sale_invoice_cash:
        case Type.opening_invoice:
        case Type.sale_credit_note:
        case Type.opening_sale_credit_note:
        case Type.sale_payment:
        case Type.sale_refund:
            return '/sales';
        case Type.purchase_order:
        case Type.purchase_goods_received_note:
        case Type.purchase_bill:
        case Type.purchase_bill_cash:
        case Type.purchase_bill_claim:
        case Type.opening_bill:
        case Type.purchase_credit_note:
        case Type.opening_purchase_credit_note:
        case Type.purchase_payment:
        case Type.purchase_refund:
            return '/purchases';
        case Type.bank_income:
        case Type.bank_expense:
        case Type.bank_transfer:
            return '/banking';
        case Type.journal_entry:
            return '/journal_entries';
        default:
            throw new Error(t`No URL found for the transaction type: : ${transactionType}`);
    }
}
